// extracted by mini-css-extract-plugin
export default {"alerts":"js6bREoM0ZIiOi2FapT0","alert":"eXeRq1Wouq8Kb_is0_ek","successAlert":"qOQXD3iwktcq_q3sbTO1"};